import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { AbsenceLeaveAttach } from '../entities/absence-leave-attach';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';

@Injectable()
export class AbsenceLeaveAttachService extends BaseCrudService<AbsenceLeaveAttach> {

  uri = '/api/absenceLeaveAttach/';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance AbsenceLeaveAttachService');
  }

  buildSentence(entity?: AbsenceLeaveAttach, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity && entity.fileName ?
          `fileName${QueryOperator.Contain}${entity.fileName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      if (entity && entity.absenceLeave && entity.absenceLeave.id) {
        query = query.concat(
          `absenceLeave.id${QueryOperator.Equal}${entity.absenceLeave.id}${QueryOperator.Split}`
        );
      }

      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  dowloadAttachment(entity?: AbsenceLeaveAttach): Observable<Blob> {
    const url = `${this.rutaServidor}${this.uri}${entity.id}/download-attachment`;
    this.spinnerService.showAll();
    return this.httpClient.get(url, { responseType: 'blob' })
      .pipe(
        tap(response => {
          //console.log('dowloadAttachment');
          //console.log(response);
          this.spinnerService.hideAll();
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/absence-leave-attach.service.ts